import React from "react";
import PropTypes from "prop-types";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";

import { normalizeCustomFields } from "../../utils/template-custom-fields";

const inputType = (type) => {
  switch (type) {
    case "date":
      return "date";
    case "datetime":
      return "datetime-local";
    default:
      return "text";
  }
};

const labelFor = (field) => String(field.caption || field.name || "").toUpperCase();

const renderLabel = (field) => {
  const label = labelFor(field);
  if (!field.tooltip) return <Form.Label>{label}</Form.Label>;

  return (
    <Form.Label>
      <span>{label}</span>
      <OverlayTrigger
        placement="top"
        delay={{ show: 150, hide: 0 }}
        overlay={<Tooltip id={`custom-field-tooltip-${field.uuid || field.name}`}>{field.tooltip}</Tooltip>}
      >
        <span className="text-muted ms-1">?</span>
      </OverlayTrigger>
    </Form.Label>
  );
};

function TemplateCustomFieldInputs({ fields, values, errors, onChange }) {
  const normalized = normalizeCustomFields(fields);
  if (!normalized.length) return null;

  return (
    <Row className="g-3 mt-1">
      {normalized.map((field) => (
        <Col xs="12" md={field.type === "string" ? 12 : 6} key={field.uuid || field.name}>
          <div className="mb-3 top-label">
            <Form.Control
              type={inputType(field.type)}
              name={field.name}
              value={values?.[field.name] || ""}
              required={field.required}
              isInvalid={Boolean(errors?.[field.name])}
              onChange={(event) => onChange?.(field.name, event.target.value)}
            />
            {renderLabel(field)}
            <Form.Control.Feedback type="invalid">
              {errors?.[field.name] || "Required"}
            </Form.Control.Feedback>
          </div>
        </Col>
      ))}
    </Row>
  );
}

TemplateCustomFieldInputs.propTypes = {
  fields: PropTypes.array,
  values: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func,
};

TemplateCustomFieldInputs.defaultProps = {
  fields: [],
  values: {},
  errors: {},
  onChange: undefined,
};

export default TemplateCustomFieldInputs;
